import { Box } from "@mui/material";
import TutorialStep1 from "assets/illustrations/tutorial/tutorial_step1.svg";
import { PhoneCheckIllustration } from "components/orderSteps/nonRfid/PhoneCheckIllustration";

// The step-1 drawing is a flat 553×553 export: a badge on the left, a phone scanning a QR on the right.
// A fridge without readers has no badge, so only the phone half is shown.
const STEP1_HEIGHT = 553;
const STEP1_CROP_LEFT = 258;
const STEP1_CROP_WIDTH = 295;

export const NonRfidTutorialScanIllustration = () => (
	<Box sx={{ width: STEP1_CROP_WIDTH, height: STEP1_HEIGHT, overflow: "hidden", flex: "none", position: "relative" }}>
		<TutorialStep1 style={{ marginLeft: -STEP1_CROP_LEFT }} />
		{/* The badge's NFC waves reach into the phone half; mask that corner with the modal background. */}
		<Box
			sx={{
				position: "absolute",
				top: 0,
				left: 0,
				width: 135,
				height: 150,
				backgroundColor: "common.white",
				borderBottomRightRadius: 70,
			}}
		/>
	</Box>
);

/** Same motif as the "finish in the app" drawer, so the last tutorial step looks like the screen the customer will see. */
export const NonRfidTutorialConfirmIllustration = () => (
	<Box sx={{ height: STEP1_HEIGHT, display: "flex", alignItems: "center", justifyContent: "center" }}>
		<PhoneCheckIllustration color="black" scale={1.5} />
	</Box>
);
